import React, { useState } from "react";
import { Modal, Table } from "react-bootstrap";
import "./table.css";

const PreviewModal = ({
  salaryList,
  salaryExtraData,
  show,
  hide,
  campusName,
  setsalaryList,
}) => {
  console.log("this is list salary==>", salaryList);

  const [selectedId, setSelectedId] = useState(null);

  const getFeeAmount = () => {
    let sum = 0;

    salaryList.forEach((element) => {
      sum += parseInt(element?.net_pay);
    });

    return sum;
  };

  const selectRow = (item, i) => {
    setSelectedId(item.id);
  };

  const renderTableRow = (salary, index) => {
    if (salary.days > 30) {
      return (
        <>
          <tr
            onClick={() => selectRow(salary, index)}
            style={{
              backgroundColor: salary.id == selectedId ? "#D3CECE" : "",
              color: "green",
            }}
            className="tbodytr text-center"
            key={salary.id}
          >
            <td className="tbodytd fixed">{index + 1}</td>
            <td className="tbodytd fixed2">{salary.employee?.emp_code}</td>
            <td className="tbodytd fixed3">{salary.employee?.full_name}</td>
            <td className="tbodytd adjusting">
              {salary.employee?.father_name}
            </td>
            <td className="tbodytd">
              {salary.account_no ? salary.account_no : "-"}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.basic_pay)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction != 1)
              ?.map((item) => {
                const match = salary.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gpf_return)}
            </td>
            <td
              className="tbodytd text-color-primary"
              style={{ backgroundColor: "darkgray" }}
            >
              {Intl.NumberFormat("en-Us").format(salary.gross_salary)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction == 1)
              ?.map((item) => {
                const match = salary?.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gp_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.welfare_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.loan_refund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.net_pay)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary?.days)}
            </td>
          </tr>
        </>
      );
    } else if (salary.days < 30) {
      return (
        <>
          <tr
            onClick={() => selectRow(salary, index)}
            style={{
              backgroundColor: salary.id == selectedId ? "#D3CECE" : "",
              color: "red",
            }}
            className="tbodytr text-center"
            key={salary.id}
          >
            <td className="tbodytd fixed">{index + 1}</td>
            <td className="tbodytd fixed2">{salary.employee?.emp_code}</td>
            <td className="tbodytd fixed3">{salary.employee?.full_name}</td>
            <td className="tbodytd adjusting">
              {salary.employee?.father_name}
            </td>
            <td className="tbodytd">
              {salary.account_no ? salary.account_no : "-"}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.basic_pay)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction != 1)
              ?.map((item) => {
                const match = salary.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gpf_return)}
            </td>
            <td
              className="tbodytd text-color-primary"
              style={{ backgroundColor: "darkgray" }}
            >
              {Intl.NumberFormat("en-Us").format(salary.gross_salary)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction == 1)
              ?.map((item) => {
                const match = salary.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gp_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.welfare_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.loan_refund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.net_pay)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary?.days)}
            </td>
          </tr>
        </>
      );
    } else {
      return (
        <>
          <tr
            onClick={() => selectRow(salary, index)}
            style={{
              backgroundColor: salary.id == selectedId ? "#D3CECE" : "",
            }}
            className="tbodytr text-center"
            key={salary.id}
          >
            <td className="tbodytd fixed">{index + 1}</td>
            <td className="tbodytd fixed2">{salary.employee?.emp_code}</td>
            <td className="tbodytd fixed3">{salary.employee?.full_name}</td>
            <td className="tbodytd adjusting">
              {salary.employee?.father_name}
            </td>
            <td className="tbodytd">
              {salary.account_no ? salary.account_no : "-"}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.basic_pay)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction != 1)
              ?.map((item) => {
                const match = salary.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gpf_return)}
            </td>
            <td
              className="tbodytd text-color-primary"
              style={{ backgroundColor: "darkgray" }}
            >
              {Intl.NumberFormat("en-Us").format(salary.gross_salary)}
            </td>
            {salaryExtraData
              ?.filter((e) => e.is_deduction == 1)
              ?.map((item) => {
                const match = salary.employee_salary_extras.find(
                  (e) => e.employee_defined_extras?.salary_extra_id == item.id,
                );

                return (
                  <td className="tbodytd" key={item.id}>
                    {Intl.NumberFormat("en-US").format(
                      Number(match?.value || 0),
                    )}
                  </td>
                );
              })}
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.gp_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.welfare_fund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.loan_refund)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary.net_pay)}
            </td>
            <td className="tbodytd">
              {" "}
              {Intl.NumberFormat("en-Us").format(salary?.days)}
            </td>
          </tr>
        </>
      );
    }
  };

  return (
    <Modal
      onHide={hide}
      size="xl"
      show={show}
      // scrollable={salaryList.length>4? true:false}
    >
      <Modal.Header>
        <Modal.Title>Salary List Details</Modal.Title>
        <h3 className="text-color-primary">{campusName.name}</h3>
        <h4>
          Net Payable Salary :{" "}
          {Intl.NumberFormat("en-Us").format(getFeeAmount())}
        </h4>

        <button onClick={hide} className="btn btn-danger">
          Close
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="tablemain">
          <table className="table">
            <thead className="tablehead">
              <tr className="tableheadtr text-center">
                <th className="background-color-primary tableHEadNAme tablehedfixed1">
                  SR.NO
                </th>
                <th className="background-color-primary tableHEadNAme tablehedfixed2">
                  Employee Code
                </th>
                <th className="background-color-primary tableHEadNAme tablehedfixed3">
                  Employee Name
                </th>
                <th className="background-color-primary tableHEadNAme tablehedfixed4">
                  Father Name
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Account No
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Basic Pay
                </th>

                {salaryExtraData
                  ?.filter((e) => e.is_deduction !== 1)
                  ?.map((item) => {
                    return (
                      <th className="background-color-primary tableHEadNAme">
                        {item?.name}
                      </th>
                    );
                  })}

                <th className="background-color-primary tableHEadNAme">
                  GPF Return
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Gross Salary
                </th>
                {salaryExtraData
                  ?.filter((e) => e.is_deduction === 1)
                  ?.map((item) => {
                    return (
                      <th className="background-color-primary tableHEadNAme">
                        {item?.name}
                      </th>
                    );
                  })}
                <th className="background-color-primary tableHEadNAme">
                  GP Fund
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Welfare Fund
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Loan Refund
                </th>
                <th className="background-color-primary tableHEadNAme">
                  Net Pay
                </th>
                <th className="background-color-primary tableHEadNAme">Days</th>
              </tr>
            </thead>
            <tbody>
              {salaryList?.map((salary, index) => (
                <>{renderTableRow(salary, index)}</>
              ))}
              <tr className="tbodytr text-center">
                <td className="tbodytd fixed">-</td>
                <td className="tbodytd fixed2">-</td>
                <td className="tbodytd fixed3">-</td>
                <td className="tbodytd adjusting">Total</td>
                <td className="tbodytd">-</td>
                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce((a, c) => a + parseInt(c.basic_pay), 0),
                  )}
                </td>
                {salaryExtraData
                  ?.filter((e) => e.is_deduction != 1)
                  ?.map((item) => {
                    const total = salaryList.reduce((sum, salary) => {
                      const match = salary.employee_salary_extras.find(
                        (e) =>
                          e.employee_defined_extras?.salary_extra_id == item.id,
                      );
                      return sum + (match ? parseInt(match.value) : 0);
                    }, 0);

                    return (
                      <td className="tbodytd" key={item.id}>
                        {Intl.NumberFormat("en-Us").format(total)}
                      </td>
                    );
                  })}
                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce((a, c) => a + parseInt(c.gpf_return), 0),
                  )}
                </td>
                <td
                  className="tbodytd text-color-primary"
                  style={{ backgroundColor: "darkgray" }}
                >
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce(
                      (a, c) => a + parseInt(c.gross_salary),
                      0,
                    ),
                  )}
                </td>
                {salaryExtraData
                  ?.filter((e) => e.is_deduction == 1)
                  ?.map((item) => {
                    const total = salaryList.reduce((sum, salary) => {
                      const match = salary.employee_salary_extras.find(
                        (e) =>
                          e.employee_defined_extras?.salary_extra_id == item.id,
                      );
                      return sum + (match ? parseInt(match.value) : 0);
                    }, 0);

                    return (
                      <td className="tbodytd" key={item.id}>
                        {Intl.NumberFormat("en-Us").format(total)}
                      </td>
                    );
                  })}
                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce((a, c) => a + parseInt(c.gp_fund), 0),
                  )}
                </td>

                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce(
                      (a, c) => a + parseInt(c.welfare_fund),
                      0,
                    ),
                  )}
                </td>
                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce(
                      (a, c) => a + parseInt(c.loan_refund),
                      0,
                    ),
                  )}
                </td>
                <td className="tbodytd">
                  {Intl.NumberFormat("en-Us").format(
                    salaryList?.reduce((a, c) => a + parseInt(c.net_pay), 0),
                  )}
                </td>
                <td className="tbodytd">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default PreviewModal;
